export type RemoveChildAction = "native" | "reparented" | "skip"

export function resolveRemoveChild(
	parent: Node,
	child: Node,
): RemoveChildAction {
	if (child.parentNode === parent) return "native"
	if (child.parentNode && parent.contains(child)) return "reparented"
	return "skip"
}

export function resolveInsertBefore(
	parent: Node,
	reference: Node | null,
): "insert" | "append" {
	if (!reference) return "insert"
	return reference.parentNode === parent ? "insert" : "append"
}

let installed = false

export function installTranslationDomGuard(): void {
	if (installed || typeof Node === "undefined") return
	installed = true

	const originalRemoveChild = Node.prototype.removeChild
	Node.prototype.removeChild = function removeChild<T extends Node>(
		this: Node,
		child: T,
	): T {
		const action = resolveRemoveChild(this, child)
		if (action === "skip") return child
		if (action === "reparented") {
			return originalRemoveChild.call(child.parentNode as Node, child) as T
		}
		return originalRemoveChild.call(this, child) as T
	}

	const originalInsertBefore = Node.prototype.insertBefore
	Node.prototype.insertBefore = function insertBefore<T extends Node>(
		this: Node,
		node: T,
		reference: Node | null,
	): T {
		const target =
			resolveInsertBefore(this, reference) === "append" ? null : reference
		return originalInsertBefore.call(this, node, target) as T
	}
}
